<ion-button fill="clear" shape="round" (click)="this.toggleMenu()">
  <ion-icon slot="icon-only" src="/assets/icon/ic_menu.svg"></ion-icon>
</ion-button>
